import { useState } from 'react'

import { Dropdown, Text } from '@/ui'

import { UserDocument } from '../lib/userDocuments.slice'
import { EditStatementDialog } from './EditStatementDialog'
import { UserDocumentActionButton } from './UserDocumentActionButton'

interface StatementActionButtonProps {
  document: UserDocument
}

export const StatementActionButton = ({
  document,
}: StatementActionButtonProps) => {
  const [isEditOpen, setIsEditOpen] = useState(false)

  return (
    <>
      <UserDocumentActionButton document={document}>
        <Dropdown.Item onClick={() => setIsEditOpen(true)}>
          <Text>Edit</Text>
        </Dropdown.Item>
      </UserDocumentActionButton>

      <EditStatementDialog
        document={document}
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
      />
    </>
  )
}
